import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import AnimateWhenVisible from 'components/transitions/AnimateWhenVisible';
import React, { HTMLAttributes } from 'react';
import { DebtType } from 'types/debt-types';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  debt: DebtType;
}

const LandaFinancingHeader = ({ className, debt }: Props) => {
  return (
    <AnimateWhenVisible className={classNames(classes.container, className)}>
      <h1 className={classes.title}>Invest in rental property mortgages.</h1>
      <Typography className={classes.subtitle}>
        Earn monthly dividends.{' '}
      </Typography>
    </AnimateWhenVisible>
  );
};

export default LandaFinancingHeader;
